import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "../../queries/marketSegments";
import { MarketSegment, SelectOption } from "../../components/containers/SegmentSelector/types";
import { useStore } from "../hooks/useStore";
import { V2 } from "@icecreamsocial/api-resources";

export const useMarketSegments = (type) => {
	const { Orchestrators } = useStore();
	const headers = { Authorization: Orchestrators.Auth.authHeader };

	const { data, isLoading } = useQuery(
		queryKeys.getMarketSegments(type),
		async (): Promise<MarketSegment[]> => {
			const { data: res } = await V2.MarketSegments.getMarketSegments({
				segmentType: type
			}, headers);
			const { marketSegments }: { marketSegments: MarketSegment[] } = res?.data;
			console.debug('marketSegments', marketSegments);
			return marketSegments;
		},
		{ enabled: !!type, refetchOnWindowFocus: false, staleTime: Infinity, cacheTime: Infinity }
	);

	function formatSegmentsToOptions() {
		if (!data?.length) return [];

		return data.reduce((opts: SelectOption[], { segmentName, id }) => [...opts, {
			value: id,
			label: segmentName,
		}], []);
	}

	function getSegmentById(searchId: string) {
		if (!data?.length) return;

		return data.filter(({ id }) => `${id}` === searchId)[0];
	}

	function getSegmentByOption(searchValue: string) {
		if (!data?.length) return;

		return formatSegmentsToOptions().filter(({ value }) => `${value}` === searchValue)
	}

	return {
		isLoading,
		data,
		formatSegmentsToOptions,
		getSegmentById,
		getSegmentByOption
	};
}
